module.exports = __webpack_public_path__ + "media/images/global/icons/bouquet-113309cbb175f50ef774f493dd764122.svg";